<template>
  <div class="productQuotationApplicationAdd container">
    <div class="searchBox">
      <div>
        <el-button size="mini" type="primary" v-acl="ProApplyCreateApply,ProApplyUpdate" v-if="saveBtnShow" @click="saveQuotationApply(2)">保存</el-button>
        <el-button size="mini" type="primary" v-acl="ProApplySubmitApply" v-if="submitBtnShow" @click="submitQuotationApply">提交</el-button>
        <el-button size="mini" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        <!--关闭-->
      </div>
      <el-form label-width="120px" ref="applyInfoForm" :model="searchForm" label-position="right" class="topform">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="单据编号">
              <el-input class="handle-input" v-model="searchForm.applyNo" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="主题">
              <el-input class="handle-input" v-model="searchForm.subject" :disabled="!saveBtnShow" clearable placeholder="请输入主题" maxlength="300" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型">
              <el-select v-model="searchForm.applyType" :disabled="true" class="handle-input" style="width:100%">
                <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="创建人">
              <el-input class="handle-input" v-model="searchForm.name" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="创建日期">
              <el-date-picker class="handle-input" type="date" value-format="yyyy-MM-dd" v-model="searchForm.createDate" placeholder="选择日期" disabled style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="产品报价明细" name="first">
        <el-row class="action-btn-row" type="flex" justify="start" align="middle">
          <el-button class="btn" size="mini" type="primary" v-acl="ProApplyCreateDetail" v-show="applyLineEdit" @click="showApplyLineAddDialogFunc()">新增</el-button>
          <el-button class="btn" size="mini" type="danger" v-acl="ProApplyDeleteDetail" v-show="applyLineEdit" @click="delSelQuotationApplyLine()">删除</el-button>
          <el-upload v-acl="ProApplyDeleteDetail" v-show="applyLineEdit" accept=".xls,.xlsx" :on-error="importDetailError" :on-success="importDetailSuccess" :before-upload="beforeUpload" :show-file-list="false" :action="importDetailUrl" multiple="false" :headers="headers">
            <el-button class="btn" type="primary" size="mini">{{$t('common.import')}}</el-button>
          </el-upload>
          <el-button class="btn" size="mini" v-acl="ProApplyExport" v-if="ttQuotationApplyId!==-1" type="primary" @click="onExport">{{$t('common.export')}}</el-button>
          <el-link v-acl="ProApplyDeleteDetail" v-show="applyLineEdit" type="button" target="_blank" href="static/template/RFQ(Material)Template.xlsx" download="RFQ(Material)Template.xlsx">
            <el-button type="primary" size="mini" style="height:100%">{{$t('common.templateDownload')}}</el-button>
          </el-link>
        </el-row>
        <ux-grid ref="applyProductTableDataRef" :data="applyProductTableData" keep-source max-height="550" highlight-current-row show-overflow="tooltip">
          <ux-table-column align="center" type="checkbox" width="80" />
          <ux-table-column align="center" title="操作" min-width="80" v-show="!disableEditor">
            <template v-slot="scope">
              <i class="el-icon-edit-outline" @click="onEdit(scope)"></i>
            </template>
          </ux-table-column>
          <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="8位码" field="eightBitCode" min-width="140"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="8位码名称" field="eightBitCodeName" min-width="200"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="提货点" field="pickupPoint" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="到货仓库（DC）" field="dcName" min-width="150"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="运输方式" field="transportaionMethod" min-width="140">
            <template v-slot="scope">
              {{scope.row.transportaionMethod | ic("COMMON",'TRANSPORTAION_METHOD')}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable title="温区" field="temperatureI18n" min-width="70"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="产品有效开始日期" field="effectiveBeginDate" min-width="150"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="入围供应商" field="supplierNames" min-width="140"></ux-table-column>
        </ux-grid>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="8位码选择" :visible.sync="dialogVisible" width="80%">
      <el-form :model="materialSearchForm" ref="materialSearchForm" label-width="120px" inline>
        <el-form-item label="8位码编号:" size="small" prop="eightBitCode">
          <el-input v-model="materialSearchForm.eightBitCode" clearable />
        </el-form-item>
        <el-form-item label="8位码名称:" size="small" prop="eightBitCodeName">
          <el-input v-model="materialSearchForm.eightBitCodeName" clearable />
        </el-form-item>
        <el-form-item label="工厂编号:" size="small" prop="plantNo">
          <el-input v-model="materialSearchForm.plantNo" clearable />
        </el-form-item>
        <el-form-item label="工厂名称:" size="small" prop="plantName">
          <el-input v-model="materialSearchForm.plantName" clearable />
        </el-form-item>
        <el-form-item label="供应商编号:" size="small" prop="supplierCode">
          <el-input v-model="materialSearchForm.supplierCode" clearable />
        </el-form-item>
        <el-form-item label="供应商名称:" size="small" prop="supplierName">
          <el-input v-model="materialSearchForm.supplierName" clearable />
        </el-form-item>
        <el-form-item label="提货点:" size="small" prop="pickupPoint">
          <el-input v-model="materialSearchForm.pickupPoint" clearable />
        </el-form-item>
        <el-form-item label="DC:" size="small" prop="dcName">
          <el-input v-model="materialSearchForm.dcName" clearable />
        </el-form-item>
        <el-form-item label="温区:" size="small" prop="temperature">
          <ic-select table="COMMON" class="handle-input" field="TEMPERATURE" v-model="materialSearchForm.temperature" clearable></ic-select>
        </el-form-item>
        <el-form-item label="运输方式:" size="small" prop="transportaionMethod">
          <ic-select table="COMMON" class="handle-input" field="TRANSPORTAION_METHOD" v-model="materialSearchForm.transportaionMethod" clearable></ic-select>
        </el-form-item>
        <el-row type="flex" justify="center">
          <el-button type="primary" @click="fatchMaterial(1)">查询</el-button>
          <el-button type="primary" @click="restQueryForm()">重置</el-button>
        </el-row>
      </el-form>
      <div style="margin-bottom:10px;">
        <el-button type="primary" @click="createDetailMateria()">选择</el-button>
        <el-button type="primary" @click="toggleSelection">{{$t('common.Deselected')}}</el-button>
      </div>
      <el-table :data="materialList" ref="materialListRef" border row-key="tmMaterialId" highlight-current-row class="dialogIntable" @selection-change="handleSelectionChangeMateria" max-height='300'>
        <el-table-column type="selection" min-width="55" :reserve-selection="true"></el-table-column>
        <el-table-column show-overflow-tooltip prop="eightBitCode" min-width="70" label="8位码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="eightBitCodeName" min-width="150" label="8位码名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="plantNo" min-width="80" label="对应工厂编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="plantName" label="对应工厂名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierCode" min-width="100" label="供应商编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" min-width="200" label="供应商名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="dcName" label="DC"></el-table-column>
        <el-table-column show-overflow-tooltip prop="temperatureI18n" min-width="60" label="温区"></el-table-column>
        <el-table-column show-overflow-tooltip prop="transportaionMethodI18n" min-width="100" label="运输方式"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange($event,'materialSearchForm','fatchMaterial')" @current-change="pageNumberChange($event,'materialSearchForm','fatchMaterial')" :current-page="materialSearchForm.pageNum" :page-sizes="pageSizeList" :page-size="materialSearchForm.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </el-dialog>
    <!-- 到货仓库 -->
    <el-dialog :visible.sync="showSelDcMultipleDialog" append-to-body width="80%">
      <SelDc ref="selectDcMultipleRef" :multipleSelectionFlag="false" @subCallMethod="selectDcMethod"></SelDc>
    </el-dialog>
    <!--入围供应商选择-->
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier ref="supplierSelRef" @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
    <!--提货点选择-->
    <el-dialog :visible.sync="showSelPickupPointDialog" append-to-body width="80%">
      <SelPickupPoint ref="selPickupPointRef" @subCallMethod="selectPickupPointMethod"></SelPickupPoint>
    </el-dialog>
    <el-dialog title="报价明细" :visible.sync="dialogEditVisible" width="80%" @close="onCancel">
      <el-table :data="tableData" ref="tableDataRef" border highlight-current-row>
        <el-table-column show-overflow-tooltip sortable prop="eightBitCode" label="8位码" width="140"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="eightBitCodeName" label="8位码名称" width="200"></el-table-column>
        <el-table-column sortable prop="pickupPoint" label="提货点" width="100">
          <template slot-scope="scope">
            <el-input @focus="showSelPickupPointDialogFunc(scope.row)" suffix-icon="el-icon-search" v-model="scope.row.pickupPoint"></el-input>
          </template>
        </el-table-column>
        <el-table-column sortable prop="dcName" label="到货仓库（DC）">
          <template slot-scope="scope">
            <el-input @click.native="showSelDcDialogFunc('1',scope.row)" suffix-icon="el-icon-search" v-model="scope.row.dcName">&nbsp;</el-input>
          </template>
        </el-table-column>
        <el-table-column sortable prop="transportaionMethod" label="运输方式" width="140">
          <template slot-scope="scope">
            <el-select v-model="scope.row.transportaionMethod">
              <el-option :key="index" v-for="(item,index) in transportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column sortable prop="temperatureI18n" label="温区" width="70"></el-table-column>
        <el-table-column sortable prop="effectiveBeginDate" label="产品有效开始日期" width="150">
          <template slot-scope="scope">
            <el-date-picker style="width:100%" value-format="yyyy-MM-dd" v-model="scope.row.effectiveBeginDate" type="date" :picker-options="(searchForm.applyType==4)?pickerOptions:''" :placeholder="$t('common.selDate')"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column sortable prop="supplierNames" label="入围供应商">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" v-if="scope.row.supplierNames">
              <p>{{scope.row.supplierNames}}</p>
              <div slot="reference" class="name-wrapper">
                <el-input @οnmοuseοver="this.title=scope.row.supplierNames" @click.native="showSelSupplierFunc(scope.row)" suffix-icon="el-icon-search" v-model="scope.row.supplierNames">&nbsp;</el-input>
              </div>
            </el-popover>
            <el-input v-else @click.native="showSelSupplierFunc(scope.row)" suffix-icon="el-icon-search" v-model="scope.row.supplierNames">&nbsp;</el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="center" style="margin-top:10px;">
        <el-button type="primary" @click="onConfirm">确认</el-button>
        <el-button type="primary" @click="onCancel">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import {
  getQuotationApplyInfo,
  getMaterial,
  createDetail,
  submitApplyInfo,
  updateApplyInfo,
  delSelQuotationApplyPro,
  createApplyInfo
} from "@/api/quoteByProduct.js";
import { applyService } from "@/api/quotation-apply/quotation-apply";
import { Message } from "element-ui";
import SelPickupPoint from '@/components/page/base-data/pickup-point-sel'
import { inputChoiceService } from "@/api/common/input-choice";
import SelDc from "@/components/page/base-data/dc-sel-page";
import SelSupplier from "@/components/page/base-data/carrier-sel-page";
import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";
import commonConstants from "@/constants/commonConstants";

let minDate = new Date();
if (minDate.getMonth() >= 10) {
  minDate.setFullYear(minDate.getFullYear() + 1);
  minDate.setMonth(minDate.getMonth() + 1 - 12);
} else {
  minDate.setMonth(minDate.getMonth() + 1);
}
minDate.setDate(1);
export default {
  name: "productQuotationApplicationAdd",
  components: {
    SelSupplier,
    SelDc,
    SelPickupPoint,
    IcSelect
  },
  data() {
    return {
      dialogEditVisible: false,
      tableData: [],
      index: null,
      activeName: 'first',
      ttQuotationApplyId: null,
      submitBtnShow: false,
      applyLineEdit: false,
      saveBtnShow: false,
      disableEditor: true,
      showSelDcMultipleDialog: false,
      showSelSupplierDialog: false,
      showSelPickupPointDialog: false,
      showUploadFlag: false,
      searchForm: {},
      materialSearchForm: {
        pageSize: 15,
        pageNum: 1,
        eightBitCode: '',
        eightBitCodeName: '',
        plantNo: '',
        plantName: '',
        supplierCode: '',
        supplierName: '',
        pickupPoint: '',
        dcName: '',
        temperature: '',
        transportaionMethod: ''
      },
      tempRows: null,
      transportaionMethodList: [],
      applyProductTableData: [],
      fileList: [],
      materialList: [],
      applyTypeList: [],
      dialogVisible: false,
      SelectionChangeMateriaObj: [],
      totalCount: 0,
      pickerOptions: {
        defaultValue: minDate,
        disabledDate: (date) => {
          let now = new Date();
          if (now.getMonth() >= 10) {
            now.setFullYear(now.getFullYear() + 1);
            now.setMonth(now.getMonth() + 1 - 12);
          } else {
            now.setMonth(now.getMonth() + 1);
          }
          now.setDate(0);
          return date.getTime() >= now.getTime() ? false : true;
        }
      },
      loadingInstance: null,
    };
  },
  computed: {
    importDetailUrl() {
      return commonConstants.baseUrl + `apply/importDetail/${this.ttQuotationApplyId}`;
    },
    headers() {
      return {
        "x-access-token": localStorage.getItem('token')
      }
    },
    baseUrl() {
      return commonConstants.baseUrl;
    }
  },
  created() {
    this.ttQuotationApplyId = this.$route.query.applyId;
    this.applyPageInit(this.$route.query.applyId);
    this.getInputChoiceValues();
  },
  methods: {
    applyPageInit: function (applyId) {
      getQuotationApplyInfo(applyId).then(res => {
        this.searchForm = res.quotationApply;
        if (res.quotationApplyProduct) {
          this.applyProductTableData = res.quotationApplyProduct;
        }
        if (
          !!res.quotationApply.ttQuotationApplyId &&
          res.quotationApply.status == "1" &&
          res.quotationApply.source == "MCD"
        ) {
          //草稿单据
          //如果是线路变更申请单
          if (res.quotationApply.applyType == "2") {
            this.applyLineEdit = false;
          }
          this.submitBtnShow = true;
          this.saveBtnShow = true;
          this.applyLineEdit = true;
          this.showUploadFlag = true;
          this.disableEditor = false;
        } else if (this.ttQuotationApplyId <= 0) {
          //新增线路申请单MCD
          this.saveBtnShow = true;
          this.disableEditor = false;
        }
        this.$refs.applyProductTableDataRef.reloadData(res.quotationApplyProduct)
      });
    },
    onEdit(scope) {
      this.dialogEditVisible = true
      this.index = scope.rowIndex
      this.tableData.push(JSON.parse(JSON.stringify(scope.row)))
    },
    onConfirm() {
      this.$refs.applyProductTableDataRef.reloadRow(this.$refs.applyProductTableDataRef.data[this.index], this.tableData[0], null)
      this.dialogEditVisible = false
      setTimeout(() => {
        this.tableData = []
      }, 500);
    },
    onCancel() {
      this.dialogEditVisible = false
      this.tableData = []
    },
    showSelPickupPointDialogFunc(row) {
      if (!!row) {
        this.tempRows = row;
      } else {
        this.tempRows = null;
      }
      this.showSelPickupPointDialog = true;
      if (this.$refs.selPickupPointRef != undefined) {
        this.$refs.selPickupPointRef.cancelSeleted();
      }
    },
    //提货点选择
    selectPickupPointMethod(pickupPoint) {
      if (!!this.tempRows) {
        this.tempRows.pickupPoint = pickupPoint.pickupPoint;
        this.tempRows.tmPickupId = pickupPoint.tmPickupPointId;
      } else {
        this.applyLineNew.pickupPoint = pickupPoint.pickupPoint;
        this.applyLineNew.tmPickupId = pickupPoint.tmPickupPointId;
      }
      this.showSelPickupPointDialog = false;
    },
    //下拉列表数据获取
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE"] = "TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE";
      mapObj["COMMON:TRANSPORTAION_METHOD"] = "COMMON:TRANSPORTAION_METHOD";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.applyTypeList = res["TT_QUOTATION_APPLY:PRODUCT_APPLY_TYPE"];
        this.transportaionMethodList = res["COMMON:TRANSPORTAION_METHOD"];
      });
    },
    showApplyLineAddDialogFunc() {
      this.fatchMaterial();
      this.dialogVisible = true;
    },
    //查询8位码
    fatchMaterial(val) {
      if (undefined != val) {
        this.materialSearchForm.pageNum = 1;
      }
      let _this = this;
      getMaterial(_this.materialSearchForm).then(res => {
        _this.materialList = res.resultData;
        _this.totalCount = res.totalCount;
      });
    },
    // 重置8位码
    restQueryForm() {
      this.materialSearchForm.pageNum = 1
      this.materialSearchForm.pageSize = 15
      this.$refs['materialSearchForm'].resetFields();
      this.$refs.materialListRef.clearSelection();
      this.fatchMaterial();
    },
    toggleSelection() {
      this.$refs.materialListRef.clearSelection();
    },
    //选择好 8位码（明细创建）
    createDetailMateria() {
      let that = this;
      that.saveQuotationApply(1)//先保存
      let datas = this.SelectionChangeMateriaObj;
      var data = datas.map(function (item) {
        let obj = {
          tmMaterialId: item["tmMaterialId"],
          tmDcId: item["tmDcId"],
          tmPickupId: item["tmPickupId"],
          temperature: item["temperature"],
          eightBitCode: item["eightBitCode"]
        };
        return obj;
      });

      createDetail(that.ttQuotationApplyId, data).then(res => {
        that.dialogVisible = false;
        that.applyPageInit(that.ttQuotationApplyId);
      });
    },
    //报价保存
    saveQuotationApply(num) {
      var that = this;
      if (!!this.ttQuotationApplyId && this.ttQuotationApplyId > 0) {
        let applyProductTableData = that.applyProductTableData;
        let quotationApplyInfo = {};
        quotationApplyInfo.quotationApply = this.searchForm;
        quotationApplyInfo.quotationApplyProduct = this.applyProductTableData;
        //修改
        updateApplyInfo(quotationApplyInfo).then(res => {
          if (num == '2') {
            if (res.meta.success) {
              that.$message({
                message: this.$t("common.saveSuccess"),
                type: "success"
              });
            }
          }
        });
      } else {
        //新增
        createApplyInfo(this.searchForm).then(res => {
          if (res.meta.success) {
            this.ttQuotationApplyId = res.data;
            this.applyPageInit(res.data);
          }
        });
      }
    },
    //线路报价申请单提交
    submitQuotationApply: function () {
      let that = this;
      if (!!this.ttQuotationApplyId) {
        //先判断DC和入围供应商是否为空
        let applyProductTableData = that.applyProductTableData;
        if (applyProductTableData.length < 1) {
          that.$message({
            message: "没有产品报价明细，请维护好明细再进行提交!",
            type: "warning"
          });
          return;
        }
        for (var i = 0; i < applyProductTableData.length; i++) {
          let item = applyProductTableData[i];
          if (that.searchForm.applyType == 4 && commonFun.isNotEmpty(item.effectiveBeginDate) && this.pickerOptions.disabledDate(new Date(item.effectiveBeginDate))) {
            that.$message({ message: that.$t("apply.pleaseSelectNextNextMonthDate"), type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.tmDcId)) {
            that.$message({ message: "第" + (i + 1) + "行" + "DC为必填", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.supplierIds)) {
            that.$message({ message: "第" + (i + 1) + "行" + "入围供应商为必填", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.tmPickupId)) {
            that.$message({ message: "第" + (i + 1) + "行" + "请选择提货点", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.transportaionMethod)) {
            that.$message({ message: "第" + (i + 1) + "行" + "请选择运输方式", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.effectiveBeginDate)) {
            that.$message({ message: "第" + (i + 1) + "行" + "产品有效开始日期不能为空", type: "warning" });
            return;
          }
        }
        that.$confirm(this.$t("common.sureSubmit"), this.$t("common.tips"), {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            //先调保存
            let quotationApplyInfo = {};
            quotationApplyInfo.quotationApply = this.searchForm;
            quotationApplyInfo.quotationApplyProduct = this.applyProductTableData;
            //修改
            updateApplyInfo(quotationApplyInfo).then(res => {
              if (res.meta.success) {
                that.submitBtnShow = false;
                let mapObj = {};
                mapObj["applyId"] = this.ttQuotationApplyId;
                mapObj["confirm"] = 0;
                console.log(mapObj);
                submitApplyInfo(mapObj).then(res => {
                  console.log(res);
                  if (res.meta.success) {
                    that.$message({
                      message: that.$t("common.submitSuccess"),
                      type: "success"
                    });
                    that.historyBack();
                  } else {
                    that
                      .$confirm(res.meta.msg, that.$t("common.tips"), {
                        confirmButtonText: that.$t("common.confirm"),
                        cancelButtonText: that.$t("common.cancel"),
                        type: "warning"
                      })
                      .then(() => {
                        //用户确认后再次提交
                        mapObj["confirm"] = 1;
                        submitApplyInfo(mapObj)
                          .then(res => {
                            that.$message({
                              message: that.$t("common.submitSuccess"),
                              type: "success"
                            });
                            that.historyBack();
                          })
                          .catch(() => {
                            that.submitBtnShow = true;
                          });
                      })
                      .catch(() => {
                        that.submitBtnShow = true;
                      });
                  }
                })
                  .catch(() => {
                    that.submitBtnShow = true;
                  });
              }
            });
          })
          .catch(() => {
          });



      }
    },
    showSelDcDialogFunc: function (method, row) {
      let that = this;
      if (!!row) {
        this.tempRows = row;
      } else {
        this.tempRows = null;
      }
      if ("1" == method) {
        if (!that.disableEditor) {
          //单选
          this.multipleSelectionBl = false;
          this.showSelDcMultipleDialog = true;
        }
      } else {
        this.multipleSelectionBl = true;
        this.showSelDcDialog = true;
      }
    },
    showSelSupplierFunc: function (row) {
      let that = this;
      if (!that.disableEditor) {
        this.showSelSupplierDialog = true;
        if (!!row) {
          this.tempRows2 = row;
        } else {
          this.tempRows2 = null;
        }
      }
    },
    //到货仓库选择
    selectDcMethod: function (dcList) {
      let that = this;
      if (this.multipleSelectionBl) {
        //多选
        let codes = new Array();
        let dcIds = new Array();
        dcList.forEach(item => {
          dcIds.push(item.tmDcId);
          codes.push(item.dcName);
        });
        that.applyLineNew.dcName = codes.join(",");
        that.applyLineNew.dcIds = dcIds;
      } else {
        //单选
        this.tempRows.tmDcId = dcList[0].tmDcId;
        this.tempRows.dcName = dcList[0].dcName;
      }
      this.showSelDcDialog = false;
      this.showSelDcMultipleDialog = false;
    },
    //供应商选择
    selectSupplierMethod: function (supList) {
      let that = this;
      let codes = new Array();
      let supplierIds = [];
      supList.forEach(item => {
        supplierIds.push(item.tmSupplierId);
        codes.push(item.supplierName);
      });
      that.tempRows2.supplierNames = codes.join(",");
      that.tempRows2.supplierIds = supplierIds;
      // that.applyData.supplierCodes = codes.join(",");
      // that.applyData.supplierIds = that.supplierIds;
      this.showSelSupplierDialog = false;
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => {
      })
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttQuotationApplyId;
      attachment.tsReckindId = 'QUOTATION_APPLY';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //文件上传
    uploadConfirm: function (item) {
      let that = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.ttQuotationApplyId;
        attachment.tsReckindId = 'QUOTATION_APPLY';
        fileService.saveFile(attachment).then((saveRes) => {
          that.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    handleSelectionChangeMateria(val) {
      this.SelectionChangeMateriaObj = val;
    },
    beforeUpload(file) {
      console.log('file', file);
      this.loadingInstance = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    importDetailSuccess: function (resp) {
      console.log('resp', resp);
      if (resp.meta.code === 200) {
        this.$message.success('导入完成,已导入数据' + resp.data + '条')
        this.applyPageInit(this.ttQuotationApplyId);
      } else {
        this.$message.error(res.meta.msg)
      }
      this.loadingInstance.close();
    },
    importDetailError: function (resp) {
      this.loadingInstance.close();
      Message.error(JSON.parse(resp.message).msg);
    },
    onExport() {
      applyService.exportDetail(this.ttQuotationApplyId).then((res) => {
        fileService.respToFile(res, '产品报价申请单' + this.searchForm.applyNo + '.xlsx');
      })
    },
    delSelQuotationApplyLine() {
      var that = this;
      let rows = this.$refs.applyProductTableDataRef.getCheckboxRecords();
      if (rows.length == 0) {
        //请选择需要删除的明细
        that.$message({
          message: that.$t("apply.selectDelLine"),
          type: "warning"
        });
      } else {
        let ids = [];
        rows.forEach(item => {
          ids.push(item.ttQuotationApplyProductId);
        });
        delSelQuotationApplyPro(ids).then(res => {
          console.log(res);
          if (res.meta.success) {
            that.$message({
              message: that.$t("common.delSuccess"),
              type: "success"
            });
            that.applyPageInit(that.ttQuotationApplyId);
          } else {
            that.$message({
              message: that.$t("common.delError"),
              type: "error"
            });
          }
        });
      }
    },
    historyBack() {
      switch (this.$route.query.source) {
        case 'productFreight':
          this.$router.push({ path: '/materialPriceData' });
          break;
        default:
          this.$router.go(-1);
      }
    }
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.handle-input {
  width: 99%;
}
.productQuotationApplicationAdd {
  .toolsBox {
    margin-bottom: 10px;
  }

  .a-link {
    text-decoration: underline;
  }

  .topform {
    margin-top: 20px;
  }
}
</style>
